var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgManRunning = function SvgManRunning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 268 233"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.658,
    d: "M119.299 50.635a19.05 19.05 0 0 0-3.705-12.664c-4.55-6.186-12.427-5.191-17.085-2.701-6.015 3.2-9.94 10.107-15.11 9.008 0 0 3.934 5.79 10.191 6.491s23.427.747 25.709-.134Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0076A8",
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.583,
    d: "m143.969 57.739 58.963.606-1.358 28.82-48.318-.495z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4BA9B",
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.665,
    d: "m136.074 44.537-.055 10.995s-7.17.316-8.528-.642-.372-12.842-.372-12.842z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4BA9B",
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.665,
    d: "M140.889 17.932a28.5 28.5 0 0 1 1.129 11.822l5.594 7.1-5.186.862s1.295 6.539-3.967 8.306c-5.263 1.768-8.909-1.825-10.807-2.686 0 0 .475-2.81-2.519-5.886 0 0-6.33-.889-6.251-4.97a11.52 11.52 0 0 1 2.785-6.947s9.003-8.954 19.222-7.601Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#131416",
    d: "M139.358 32.098c.382-.01.675-.596.654-1.308-.02-.712-.346-1.28-.729-1.268-.382.01-.675.596-.654 1.308s.347 1.28.729 1.268"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.665,
    d: "M140.096 40.708a8.4 8.4 0 0 1-4.911-2.51"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#131416",
    d: "M125.539 36.923c.9 1.698 1.66 3.466 2.27 5.288.47 1.69-1.059 1.85-1.042 3.356 0 0-9.617-13.369-10.747-16.322-1.131-2.953-3.459-8.593-.644-12.149s7.465-3.955 9.531-2.006c0 0 1.375-8.754 10.233-5.875 0 0 1.069-4.557 5.627-5.348s7.678 1.753 8.533 5.97-2.938 9.85-9.962 7.488c0 0-2.605 8.009-10.724 4.64 0 0 .098 3.39-3.57 5.587 0 0 1.886 1.384 1.964 1.504s-6.908-.22-6.34 4.153c.567 4.375 4.871 3.714 4.871 3.714"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.583,
    d: "M91.015 108.743s1.086-1.388-2.924 14.56c-2.136 8.497-9.248 32.163-22.727 42.169-9.746 7.252-25.592 10.032-25.592 10.032l1.593 41.404s68.77-13.366 81.647-77.692l2.753-23.261z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M142.064 108.622s11.992-2.525 35.712 6.431c14.627 5.507 44.621 36.154 44.621 36.154l-20.435 31.808S179.631 159.659 160.967 150c-3.038-1.575-25.394-6.831-41.909-7.187 0 0-28.022-1.727-27.97-31.051"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.583,
    d: "M142.064 108.622s11.992-2.525 35.712 6.431c14.627 5.507 44.621 36.154 44.621 36.154l-20.435 31.808S179.631 159.659 160.967 150c-3.038-1.575-25.394-6.831-41.909-7.187 0 0-28.022-1.727-27.97-31.051"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#E35205",
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.583,
    d: "M93.59 50.783S72.708 85.637 69.467 91.35c-3.242 5.713 1.236 15.98 9.428 15.79s9.733-5.114 9.733-5.114l19.901-46.498z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.583,
    d: "m89.843 49.324-22.12 37.333s-1.742 2.907 1.744 4.7l24.124-40.574z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#E35205",
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.583,
    d: "M104.943 59.642a11.063 11.063 0 1 0-.64-22.117 11.063 11.063 0 0 0 .64 22.117Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#0076A8",
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.583,
    d: "M111.377 53.356a111.5 111.5 0 0 0-26.675 33.78c-9.977 19.664 3.473 34.862 26.528 28.609 19.526-5.316 28.259-6.023 28.259-6.023l-6.702-27.8 15.284-5.559s-4.126-13.14-14.249-21.024-19.215-4.113-22.445-1.983Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.712,
    d: "m132.814 81.922-29.655 7.061m15.056-3.632 7.33-10.019"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.583,
    d: "M154.634 77.788s-2.657-13.957-13.486-22.567c-13.892-11.012-22.135-9.063-22.135-9.063l.286 4.477s8.36-.242 14.571 5.204c12.053 10.563 14.228 20.523 14.228 20.523s1.783 7.413 6.536 1.426ZM83.887 64.643l6.281 3.401-7.183 13-6.628-3.425z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4BA9B",
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.583,
    d: "M132.814 81.922s3.041-.903 5.092-1.797 3.047-3.264 2.909-7.583c-.139-4.318.385-6.614 2.922-6.192s4.331 8.955 4.524 10.95c.194 1.997 3.832 4.844 6.373.495a26.3 26.3 0 0 0-1.533-6.063 25 25 0 0 1 4.533.228c1.259.33 4.733 3.623 2.574 7.54 0 0 5.468 1.348 1.838 7.947 0 0 5.226 3.317-.709 9.27 0 0 2.653.44 1.949 3.534-.705 3.094-2.878 3.273-8.003 4.86s-15.916 4.146-15.916 4.146z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.658,
    d: "M160.221 79.5s-1.561 4.428-7.223 5.766m9.062 2.18a13.56 13.56 0 0 1-6.87 4.13m6.161 5.141s-2.796 1.621-4.171 1.722"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#0076A8",
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.583,
    d: "m233.846 150.074 9.163 7.098s2.239-8.684 6.941-11.521c7.463-4.505 12.566 4.386 12.566 4.386l-29.33 37.244-14.164-12.945z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.488,
    d: "m237.227 152.704-2.199 3.491m4.445-1.853-2.206 3.498"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    stroke: "#131416",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.563,
    d: "M237.724 151.373s1.496-9.273 4.131-7.327c2.884 2.109-4.131 7.327-4.131 7.327"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    stroke: "#131416",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.563,
    d: "M237.725 151.373s4.516-5.03 5.743-2.969-3.995 3.122-5.743 2.969"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#131416",
    d: "m262.517 150.051 3.298 3.277-29.66 36.636-2.969-2.683z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.488,
    d: "M240.727 177.487s-7.544-6.031-15.865 2.136m34.083-29.184s-4.401-5.505-8.708-1.213"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#0076A8",
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.583,
    d: "m34.68 213.871-11.587-.112s3.456 8.267 1.426 13.368c-3.227 8.095-12.66 4.106-12.66 4.106l.88-47.393 19.107 1.761z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.488,
    d: "m30.411 213.839-.357-4.116m-2.424 4.162-.357-4.115"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    stroke: "#131416",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.563,
    d: "M30.81 215.205s4.407 8.294 1.13 8.334c-3.56.056-1.13-8.334-1.13-8.334"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    stroke: "#131416",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.563,
    d: "M30.81 215.205s-.558 6.734-2.783 5.835 1.303-4.903 2.783-5.835"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#131416",
    d: "m11.86 231.233-4.606-.62 1.499-47.112 3.986.339z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.488,
    d: "M12.643 196.207s9.664.243 11.352-11.288m-9.52 43.849s6.836 1.723 7.666-4.293"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4BA9B",
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.583,
    d: "m220.287 154.26 7.702 5.409-8.967 14.667-8.055-5.399z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#0076A8",
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.583,
    d: "M174.263 113.756a11.9 11.9 0 0 0 1.178 7.074 11.9 11.9 0 0 0 5.032 5.111c7.682 4.249 12.509-1.313 12.509-1.313s-11.514-9.289-18.719-10.872Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4BA9B",
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.583,
    d: "m32.272 189.28 7.74-.075.739 15.166-6.974.799z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#0076A8",
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.583,
    d: "M110.253 170.836s-19.542-1.823-13.659 16.682c0-.027 10.427-10.413 13.659-16.682Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#131416",
    d: "M90.883 113.104s-1.176 34.596 29.266 37.406l1.97-7.441s-28.314 1.323-31.236-29.965m-50.87 76.101-3.533 15.561 4.27-.395zm92.801-107.284 12.193 25.95-5.633 1.385z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4BA9B",
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.57,
    d: "M209.122 60.29c1.89-1.752 1.752-5.582 1.776-7.565.024-1.982 1.098-4.483 3.739-4.451s3.285 1.88 3.255 5.05l-.367 5.154c2.459.128 4.924.102 7.381-.078 3.172-.153 10.336-1.385 11.525 1.702 1.409 3.671-2.766 4.797-2.766 4.797s8.072-1.076 8.302 3.105c.249 4.62-10.533 3.508-10.533 3.508s8.071.302 8.2 3.115c.182 3.93-4.902 3.657-4.902 3.657s1.899 2.558-.427 3.534c-3.855 1.625-11.727 1.175-16.933 1.122l-15.588.689.851-21.435a7.93 7.93 0 0 0 6.487-1.905Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.57,
    d: "m225.473 65.061 8.375-.188m-10.373 6.652 8.523-.03m-6.919 6.926 9.455-.186"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.543,
    d: "M61.834 100.088s-.564 12.387 14.309 13.483"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#131416",
    d: "m127.894 43.715 8.077 7.564.124-4.632s-6.115-.963-8.201-2.932m74.734 18.459 4.162 21.134-5.013.3zm17.658 92.086-5.992 16.867-3.328-2.19z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.543,
    d: "M80.902 156.723s-7.869 13.95-21.248 18.036"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.583,
    d: "M103.025 40.534s8.312.173 9.78 8.233"
  })));
};
export default SvgManRunning;